import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FormInput } from '@shared/models/form-input';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-form-input-text',
  templateUrl: './form-input-text.component.html',
  styleUrls: ['./form-input-text.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule]
})
export class FormInputTextComponent {
  @Input() field!: FormInput;
  @Input() form!: UntypedFormGroup;
  @Input() readonly = false;
  @Input() inlineLabel = false;

  get Control() {
    return this.form.get(this.field.control) as UntypedFormControl;
  }
}
